// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_o1-0";
export var buttonContainer = "_o1-3";
export var cancelButton = "_o1-4";
export var headerSection = "_o1-6";
export var headerTitle = "_o1-9";
export var messageSideLeft = "_o1-1";
export var messageSideRight = "_o1-2";
export var orderNumberContainer = "_o1-7";
export var orderNumberLabel = "_o1-8";
export var submitButton = "_o1-5";